

































































import { Component, Vue } from "vue-property-decorator";
import RequestHandler from "@/assets/ts/requestHandler";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import EnglishLang from "../../public/languages/English.json";
import store from "@/store";
import LoadingButton from "@/components/LoadingButton.vue";

const RH = new RequestHandler();

@Component({
  components: { LoadingButton }
})
export default class SalvageApplication extends Vue {
  private transactionID = undefined;
  private email = undefined;
  private loading = false;
  private store = store;
  private englishLang = EnglishLang;

  private emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  private rules = {
    required: (value: any) => !!value || this.englishLang.requiredErrorMessage,
    email: (value: string) => {
      return (
        this.emailRegex.test(value) ||
        this.englishLang.invalidEmailAddressErrorMessage
      );
    }
  };

  private async validateStatusInfo() {
    if (this.checkStatusForm.validate()) {
      const payload = {
        transactionID: Number(this.transactionID) ?? 0,
        transactionType: "O20",
        emailAddress: this.email ?? ""
      };
      try {
        this.loading = true;
        const res = await RH.checkSalvageApplicationStatus(payload);
        this.store.dispatch("setGlobalAlertState", {
          description: `${this.englishLang.salvageApplicationStatusCheckMessage} "${res.transactionStatus}"`,
          variant: "info"
        });
      } catch (error) {
        this.store.dispatch("setGlobalAlertState", {
          description: this.englishLang
            .salvageApplicationStatusCheckErrorMessage,
          variant: "error"
        });
      } finally {
        this.loading = false;
      }
    }
  }

  get checkStatusForm(): Vue & { validate: () => boolean } {
    return this.$refs.checkStatusForm as Vue & { validate: () => boolean };
  }
}
